import React from 'react'

const CallToAction = ({ callToActionText, callToActionKeyword, type, size }) => {
    return (
        
        <h1 className={`${size} mb-5 font-weight-bolder text-uppercase`}>
            {
                callToActionText && 
                    callToActionText.split(/[ ,]+/).map(word => {
                        if(callToActionKeyword === word )
                            return (
                                <span key={word} className={type}>
                                    {`${word} `}
                                    </span>
                            )
                            return (
                            `${word} ` 
                    )
                    })
            }
        </h1>
    )
     
}

export default CallToAction
